module.exports = "/static/assets/a0531beb3feee882ee9f052ae34d71bb.png";